// Application class
class RudderApp {
  constructor() {
    this.name = 'RudderLabs JavaScript SDK';
    this.namespace = 'com.rudderlabs.javascript';
    this.version = 'process.package_version';
  }
}
export default RudderApp;
